import $ from 'jquery';

/*  Creates a tabset on an specified div.
    @param opts - {} - not required.

        opts.selected - optional - object that you want to be selected at start.
        opts.iconPos  - position of the icon in the list; TODO:add option to have icons in tabs

*/
$.fn.sdaTabs = function(opts = {}) {
    return this.each((__, tabContainer) => {
        const $tabContainer = $(tabContainer);
        const $ul = $tabContainer.find('ul');
        const $selected = opts.selected ? opts.selected : $ul.find('li:first-of-type');
        const data = $selected.data();
        const resetTabs = () => {
            $tabContainer.find('.sda-tab').removeClass('tab-active');
            $tabContainer.find('.sda-tab-content').removeClass('tab-active');
        };

        resetTabs();

        $selected.addClass('tab-active');

        if (data) {
            $(data.content).addClass('tab-active');
        }

        $tabContainer
            .find('.sda-tab')
            .off('click.sdaTabs')
            .on('click.sdaTabs', function() {
                const tab = $(this);
                const tabData = tab.data();

                resetTabs();
                tab.addClass('tab-active');
                const $content = $(tabData.content).addClass('tab-active');
                $tabContainer.trigger('show.sdaTabs', {$content});
            });
    });
};
